import axios from 'axios';
import { localStorage as localStorageConstants } from 'constants/index';
import resolvePath from 'utils/resolvePath';
// Action
const OPEN = 'organizations/open';
const CLOSE = 'organizations/close';
const POST_SIGNIN_REQUEST = 'organizations/postSigninRequest';
const POST_SIGNIN_SUCCESS = 'organizations/postSigninSuccess';
const POST_SIGNIN_FAILURE = 'organizations/postSigninFailure';
const GET_USERS_REQUEST = 'organizations/getUsersRequest';
const GET_USERS_SUCCESS = 'organizations/getUsersSuccess';
const GET_USERS_FAILURE = 'organizations/getUsersFailure';
// Action Creator
export const open = () => {
    return {
        type: OPEN,
    };
};
export const close = () => {
    return {
        type: CLOSE,
    };
};
export const postSigninRequest = () => {
    return {
        type: POST_SIGNIN_REQUEST,
    };
};
export const postSigninSuccess = (me) => {
    return {
        payload: {
            me,
        },
        type: POST_SIGNIN_SUCCESS,
    };
};
export const postSigninFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_SIGNIN_FAILURE,
    };
};
export const postSignin = (request) => (dispatch) => {
    dispatch(postSigninRequest());
    return axios
        .post(resolvePath.api('organizations/signin'), request)
        .then((response) => {
        dispatch(postSigninSuccess(response.data));
        if (response.data.auth_token) {
            localStorage.setItem(localStorageConstants.ORGANIZATIONS_AUTH_TOKEN_KEY, response.data.auth_token);
            localStorage.setItem(localStorageConstants.WEB_SOCKET_TOKEN_KEY, response.data.web_socket_token);
            dispatch(getUsers(response.data.auth_token));
            dispatch(open());
        }
    })
        .catch((error) => {
        dispatch(postSigninFailure(error));
        throw error;
    });
};
export const getUsersRequest = () => {
    return {
        type: GET_USERS_REQUEST,
    };
};
export const getUsersSuccess = (users) => {
    return {
        payload: {
            users,
        },
        type: GET_USERS_SUCCESS,
    };
};
export const getUsersFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_USERS_FAILURE,
    };
};
export const getUsers = (authToken) => (dispatch) => {
    dispatch(getUsersRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .get(resolvePath.api('organizations/users'), config)
        .then((response) => dispatch(getUsersSuccess(response.data)))
        .catch((error) => {
        dispatch(getUsersFailure(error));
        throw error;
    });
};
const initialState = {
    error: null,
    isFetching: false,
    isOpened: true,
    me: {
        auth_token: '',
        id: 0,
    },
    users: [],
};
export default (state = initialState, action) => {
    switch (action.type) {
        case OPEN: {
            return Object.assign(Object.assign({}, state), { isOpened: true });
        }
        case CLOSE: {
            return Object.assign(Object.assign({}, state), { isOpened: false });
        }
        case POST_SIGNIN_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case POST_SIGNIN_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, me: Object.assign({}, action.payload.me) });
        }
        case POST_SIGNIN_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case GET_USERS_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_USERS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, users: action.payload.users });
        }
        case GET_USERS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        default: {
            return state;
        }
    }
};
